import React, { useEffect, useState } from "react";
import { Row, Container, Col, Card } from "react-bootstrap";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";

import Title from "../TitleIzquierda";
import { logrosData } from "../../constants/logrosData";

import "../../styles/components/Logro.scss";

const boxVariant = {
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  hidden: { opacity: 0, y: 50 },
};

export default function Logros() {
  const control = useAnimation();
  const [ref, inView] = useInView();
  const [count, setCount] = useState(Array(logrosData.length).fill(0));

  useEffect(() => {
    if (inView) {
      control.start('visible');
      setCount(logrosData.map(() => 0));

      const interval = setInterval(() => {
        setCount((prevCount) => {
          const nextCount = prevCount.map((count, index) => {
            const finalValue = logrosData[index].dato;
            const increment = Math.ceil(finalValue / 25);
            return count + increment > finalValue ? finalValue : count + increment;
          });

          if (nextCount.every((value, index) => value === logrosData[index].dato)) {
            clearInterval(interval);
          }

          return nextCount;
        });
      }, 20);
    }
  }, [control, inView]);

  return (
    <motion.div className="box Logro" ref={ref} variants={boxVariant} initial="hidden" animate={control}>
      <Title titulo="Actividades Ejecutadas" scroll={inView} />
      <Container className="Logro mt-3 mb-3">
        <Row>
          {logrosData.map((data, index) => (
            <Col key={index} xl={3} lg={3} md={6} sm={6} xs={6}>
              <Card border="0" className="cardTransparent">
                <Card.Body>
                  <Card.Title className="titulo" >
                    {data.titulo}
                  </Card.Title>
                  <Card.Text className="texto">{count[index]}+</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </motion.div>
  );
}